import { Component } from '@angular/core';

@Component({
  selector: 'app-chip',
  templateUrl: './chip.component.html',
  styleUrls: ['./chip.component.scss']
})
export class ChipComponent {
  sizeList = ['small', 'large'];
  statusList = ['default', 'primary', 'success', 'warning', 'danger', 'normal', 'active'];
  selectedSize = 'small';
  selectedStatus = 'default';
  hasCloseButton = false;
  hasOutline = false;
  disabled = false;
  hasStatusIcon = true;
  icon = '';
  ariaLabel = 'Chips';
  iconText = 'icon name';
}